import '../styles/index.css'

const ON_CHANGE_DEBOUNCE_TIMER = 300

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
}

let subscribers = {}

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = []
  }

  subscribers[eventName] = [...subscribers[eventName], callback]

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback
    })
  }
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data)
    })
  }
}

(function () {

  window.omgTheme = window.omgTheme || {}

  class VariantSelects extends HTMLElement {
    constructor() {
      super()
      this.addEventListener('change', this.onVariantChange)
    }
  
    onVariantChange() {
      this.updateOptions()
      this.updateMasterId()
      this.toggleAddButton(true, '', false)
      this.updatePickupAvailability()
      this.removeErrorMessage()
      this.updateVariantStatuses()
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true)
        this.setUnavailable()
      } else {
        this.updateMedia()
        this.updateURL()
        this.updateVariantInput()
        this.renderProductInfo()
        this.updateShareUrl()
      }
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value)
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option
          })
          .includes(false)
      })
    }
  
    // TODO change this to use the media gallery component
    updateMedia() {
      if (!this.currentVariant) return
      if (!this.currentVariant.featured_media) return
  
      document.querySelector('product-media')?.selectImage(this.currentVariant.id)
    }
  
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
  
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`)
      if (!shareButton || !shareButton.updateUrl) return
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      )
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]')
        input.value = this.currentVariant.id
        input.dispatchEvent(new Event('change', { bubbles: true }))
      })
    }
  
    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(
        (variant) => this.querySelector(':checked').value === variant.option1
      )
      const inputWrappers = [...this.querySelectorAll('.product-form__input')]
      inputWrappers.forEach((option, index) => {
        if (index === 0) return
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) => variant.available && variant[`option${index}`] === previousOptionSelected
          )
          .map((variantOption) => variantOption[`option${index + 1}`])
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
      })
    }
  
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.innerText = input.getAttribute('value')
        } else {
          input.innerText = window.variantStrings.unavailable_with_option.replace(
            '[value]',
            input.getAttribute('value')
          )
        }
      })
    }
  
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability')
      if (!pickUpAvailability) return
  
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id)
      } else {
        pickUpAvailability.removeAttribute('available')
        pickUpAvailability.innerHTML = ''
      }
    }
  
    removeErrorMessage() {
      const section = this.closest('section')
      if (!section) return
  
      const productForm = section.querySelector('product-form')
      if (productForm) productForm.handleErrorMessage()
    }
  
    renderProductInfo() {
      const requestedVariantId = this.currentVariant.id
      const sectionId = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
  
      fetch(
        `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
          this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
        }`
      )
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return
  
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`price-${this.dataset.section}`)
          const source = html.getElementById(
            `price-${
              this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
            }`
          )
          const skuSource = html.getElementById(
            `Sku-${
              this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
            }`
          )
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`)
          const inventorySource = html.getElementById(
            `Inventory-${
              this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
            }`
          )
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`)
  
          const volumePricingSource = html.getElementById(
            `Volume-${
              this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
            }`
          )
  
          const pricePerItemDestination = document.getElementById(
            `Price-Per-Item-${this.dataset.section}`
          )
          const pricePerItemSource = html.getElementById(
            `Price-Per-Item-${
              this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
            }`
          )
  
          const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`)
          const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`)
          const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`)
  
          if (volumeNote) volumeNote.classList.remove('hidden')
          if (volumePricingDestination) volumePricingDestination.classList.remove('hidden')
          if (qtyRules) qtyRules.classList.remove('hidden')
  
          if (source && destination) destination.innerHTML = source.innerHTML
          if (inventorySource && inventoryDestination)
            inventoryDestination.innerHTML = inventorySource.innerHTML
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML
            skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'))
          }
  
          if (volumePricingSource && volumePricingDestination) {
            volumePricingDestination.innerHTML = volumePricingSource.innerHTML
          }
  
          if (pricePerItemSource && pricePerItemDestination) {
            pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML
            pricePerItemDestination.classList.toggle(
              'hidden',
              pricePerItemSource.classList.contains('hidden')
            )
          }
  
          const price = document.getElementById(`price-${this.dataset.section}`)
  
          if (price) price.classList.remove('hidden')
  
          if (inventoryDestination)
            inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '')
  
          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`)
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            'Sold out'
          )
  
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId,
              html,
              variant: this.currentVariant,
            },
          })
        })
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`)
      if (!productForm) return
      const addButton = productForm.querySelector('[name="add"]')
      const addButtonText = productForm.querySelector('[name="add"] > span')
      if (!addButton) return
  
      if (disable) {
        addButton.setAttribute('disabled', 'disabled')
        if (text) addButtonText.textContent = text
      } else {
        addButton.removeAttribute('disabled')
        addButtonText.textContent = 'Add to cart'
      }
  
      if (!modifyClass) return
    }
  
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`)
      const addButton = button.querySelector('[name="add"]')
      const addButtonText = button.querySelector('[name="add"] > span')
      const price = document.getElementById(`price-${this.dataset.section}`)
      const inventory = document.getElementById(`Inventory-${this.dataset.section}`)
      const sku = document.getElementById(`Sku-${this.dataset.section}`)
      const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`)
      const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`)
      const volumeTable = document.getElementById(`Volume-${this.dataset.section}`)
      const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`)
  
      if (!addButton) return
      addButtonText.textContent = 'Unavailable'
      if (price) price.classList.add('hidden')
      if (inventory) inventory.classList.add('hidden')
      if (sku) sku.classList.add('hidden')
      if (pricePerItem) pricePerItem.classList.add('hidden')
      if (volumeNote) volumeNote.classList.add('hidden')
      if (volumeTable) volumeTable.classList.add('hidden')
      if (qtyRules) qtyRules.classList.add('hidden')
    }
  
    getVariantData() {
      this.variantData =
        this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
      return this.variantData
    }
  }
  
  customElements.define('variant-selects', VariantSelects)
  
  class VariantRadios extends VariantSelects {
    constructor() {
      super()
    }
  
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled')
        } else {
          input.classList.add('disabled')
        }
      })
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('.fieldset'))
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
      })
    }
  }
  
  customElements.define('variant-radios', VariantRadios)
  
  class MobileMenu extends HTMLElement {
    isHidden = false
  
    constructor() {
      super()
  
      this.toggleMenu = this.toggleMenu.bind(this)
  
      document.querySelector('#mobile-menu-toggle')?.addEventListener('click', this.toggleMenu)
      this.querySelectorAll('.has-child')?.forEach((el) => {
        el.addEventListener('click', (e) => this.toggleSubMenu(e, el))
      })
    }
  
    toggleSubMenu(e: Event, el: HTMLElement) {
      e.preventDefault()
      el.querySelector('svg')?.classList.toggle('-rotate-180')
      el.parentElement?.querySelector('.children')?.classList.toggle('max-h-screen')
    }
  
    toggleMenu() {
      this.isHidden = !this.isHidden
  
      if (!this.isHidden) {
        document.querySelector('body')?.classList.remove('overflow-hidden')
  
        this.classList.remove('max-h-screen')
        setTimeout(() => {
          this.classList.add('hidden')
        }, 300)
      } else {
        this.classList.remove('hidden')
        document.querySelector('body')?.classList.add('overflow-hidden')
  
        setTimeout(() => {
          this.classList.add('max-h-screen')
        }, 50)
      }
    }
  }
  customElements.define('mobile-menu', MobileMenu)
  
  class QuickBuyButton extends HTMLElement {
    constructor() {
      super()
  
      this.addEventListener('click', (e) => this.onQuickBuyClick(e))
    }
  
    onQuickBuyClick(e) {
      e.preventDefault()
  
      document.querySelectorAll('form-quick-buy').forEach((el) => {
        el.setAttribute('aria-hidden', 'true')
      })
  
      document
        .getElementById(this.getAttribute('aria-controls') || '')
        ?.parentElement?.setAttribute('aria-hidden', 'false')
    }
  }
  customElements.define('quick-buy-button', QuickBuyButton)
  class ProductQuickBuy extends HTMLElement {
    constructor() {
      super()
  
      this.form = this.querySelector('form')
      this.variants = JSON.parse(
        this.form?.querySelector('[type="application/json"]')?.textContent || '[]'
      )
  
      this.querySelectorAll('select')?.forEach((el) => {
        el.addEventListener('change', (e) => this.updateVariant(e))
      })
  
      this.form?.addEventListener('submit', (e) => this.onQuickBuyClick(e))
    }
  
    updateVariant(e) {
      let options = {}
      this.querySelectorAll('select')?.forEach((el) => {
        options[el.name] = el.value
      })
  
      const variant = this.variants.find((v) => {
        return v.options.every((option, i) => {
          return options[`option${i + 1}`] === option
        })
      })
  
      if (!variant?.available) return
  
      const VariantID = this.querySelector('[name="id"]') || {}
      const price = this.querySelector('.price') || {}
  
      price.innerHTML = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: Shopify.currency.active,
        currencyDisplay: 'narrowSymbol',
      }).format(variant.price / 100)
  
      VariantID.value = variant.id
    }
  
    onQuickBuyClick(e) {
      e.preventDefault()
  
      window.addToCartHandler && window.addToCartHandler(this.form)
    }
  }
  
  customElements.define('form-quick-buy', ProductQuickBuy)
  
  class DeferredMedia extends HTMLElement {
    constructor() {
      super()
      const poster = this.querySelector('[id^="Deferred-Poster-"]')
      if (!poster) return
  
      window.pauseAllMedia = () => {
        document.querySelectorAll('.js-youtube').forEach((video) => {
          video.contentWindow.postMessage(
            '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
            '*'
          )
        })
        document.querySelectorAll('.js-vimeo').forEach((video) => {
          video.contentWindow.postMessage('{"method":"pause"}', '*')
        })
        document.querySelectorAll('video').forEach((video) => video.pause())
        document.querySelectorAll('product-model').forEach((model) => {
          if (model.modelViewerUI) model.modelViewerUI.pause()
        })
      }
  
      poster.addEventListener('click', this.loadContent.bind(this))
    }
  
    loadContent(focus = true) {
      window.pauseAllMedia()
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div')
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))
  
        this.setAttribute('loaded', true)
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'))
        if (focus) deferredElement.focus()
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play()
        }
      }
    }
  }
  
  customElements.define('deferred-media', DeferredMedia)

  function initTheme() {
    
    document.querySelectorAll('.faq-handle').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()

        const ariaElement = el.closest('.group');
        if (!ariaElement) return
  
        ariaElement.setAttribute('aria-expanded', ariaElement.getAttribute('aria-expanded') === 'true' ? 'false' : 'true')
      })
    })

    const initScrollIndicators =  (el: Element) => {
      console.log('initScrollIndicators', el)
      if (!(el instanceof Element)) return

        let pages = Math.ceil(el.scrollWidth / el.clientWidth)
        window.addEventListener('resize', (e) => {
          pages = Math.ceil(el.scrollWidth / el.clientWidth)
        })
    
        if (document.body.clientWidth < 500) {
          pages = el.querySelectorAll('.scroll-item').length
        }
    
        let timeout: NodeJS.Timeout
    
        function resetTimeout() {
          if (el.classList.contains('auto-scroll')) {
            clearTimeout(timeout)
    
            const scrollItems = el.querySelectorAll('.scroll-item')
            let scrollIndex = 0
    
            function scroll() {
              scrollIndex = (scrollIndex + 1) % scrollItems.length
              el.scrollLeft = el.clientWidth * scrollIndex
    
              timeout = setTimeout(scroll, 5000)
            }
    
            timeout = setTimeout(scroll, 5000)
          }
        }
        resetTimeout()
    
        const buttonNext = el.parentNode?.querySelector('.scroll-button-next')
        const buttonPrev = el.parentNode?.querySelector('.scroll-button-prev')
    
        buttonNext?.addEventListener('click', (e) => {
          el.scrollLeft += el.clientWidth
        })
        buttonPrev?.addEventListener('click', (e) => {
          el.scrollLeft -= el.clientWidth
        })
    
        let scrollIndicators = el.parentNode?.querySelector('& > .scroll-indicators')
        if (!scrollIndicators) return
    
        let indicators: HTMLAnchorElement[] = []
        let scrollContainer = scrollIndicators?.querySelector('.scroll-indicator-container');
        if (!scrollContainer) {
          scrollContainer = document.createElement('div')
          scrollContainer.classList.add('scroll-indicator-container')
        }
    
        // create scroll indicators
        for (let i = 0; i < pages; i++) {
          const indicator = document.createElement('a')
          indicator.href = '#'
          indicator.addEventListener('click', (e) => {
            e.preventDefault()
    
            resetTimeout()
    
            el.scrollLeft = el.clientWidth * i
          })
    
          indicator.classList.add('scroll-indicator')
          scrollContainer.appendChild(indicator)
    
          indicators.push(indicator)
        }
        scrollIndicators?.appendChild(scrollContainer)
    
        const page = Math.round((el.scrollLeft / (el.scrollWidth - el.clientWidth)) * pages)
        const scrollIndicator = scrollContainer.children[page]
    
        scrollIndicator?.classList.add('active')
    
        el.addEventListener('scroll', (e) => {
          const scrollPercent =
            Math.round((el.scrollLeft / (el.scrollWidth - el.clientWidth)) * 100) * pages - 50 * pages
          const scrollOffset = scrollPercent / (pages * -100)
    
          const page = Math.round((el.scrollLeft / (el.scrollWidth - el.clientWidth)) * (pages - 1))
    
          const scrollIndicator = scrollContainer?.children[page]
    
          indicators.forEach((indicator, index) => {
            indicator.classList.remove('active')
    
            // fade out indicators after 4th item from active
          })
    
          scrollIndicator?.classList.add('active')
    
          resetTimeout()
        })
      }

      window.omgTheme.initScrollIndicators = initScrollIndicators;
  
    document.querySelectorAll('.scroll-container').forEach(el => initScrollIndicators(el))
  
    function Marquee(parentSelector: Element, speed: number) {
      if (!parentSelector) return
  
      const childHolderElement = parentSelector.children[0]
      const firstElement = childHolderElement.children[0]
  
      const clone = childHolderElement.innerHTML
      let i = 0
  
      childHolderElement.insertAdjacentHTML('beforeend', clone)
      childHolderElement.insertAdjacentHTML('beforeend', clone)
  
      const step = () => {
        childHolderElement.style.transform = `translateX(-${i}px)`
        i = i + 0.5
        if (i > firstElement.clientWidth + 16) {
          i = 0
        }
  
        requestAnimationFrame(step)
      }
  
      requestAnimationFrame(step)
    }
  
    document.querySelectorAll('.marquee').forEach((el) => {
      Marquee(el, 0.3)
    })
  
    document.querySelectorAll('[data-show-more]').forEach((el) => {
      const target = document.getElementById(el.getAttribute('data-show-more') || '')
      if (!target) return
  
      el.addEventListener('click', (e) => {
        e.preventDefault()
        target.classList.toggle('show')
  
        el.innerHTML = target.classList.contains('show') ? 'Show less' : 'Show more'
      })
    })
  }

  if (document.readyState !== 'loading') {
    initTheme();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
        initTheme();
    });
  }
})();